export const HOLIDAYLIST_SEARCH = 'HOLIDAYLIST_SEARCH';
export const HOLIDAYLIST_PAGE = 'HOLIDAYLIST_PAGE';
export const HOLIDAYLIST_YEAR = 'HOLIDAYLIST_YEAR';